import { memo } from 'react'
import { UserCircleIcon, XMarkIcon } from '@heroicons/react/24/outline'

/**
 * AvatarUploadField - Avatar image upload and preview
 * Handles file selection, preview, and removal
 */
const AvatarUploadField = memo(function AvatarUploadField({
  user,
  avatarPreview,
  avatarError,
  onAvatarChange,
  onRemoveAvatar,
  onAvatarError,
  t
}) {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="h-20 w-20 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden ring-2 ring-gray-200">
        {avatarPreview || (user.avatar && !avatarError) ? (
          <img 
            src={avatarPreview || user.avatar} 
            alt="Profile preview"
            className="h-full w-full object-cover"
            onError={() => onAvatarError(true)}
          />
        ) : (
          <UserCircleIcon className="h-16 w-16 text-gray-400" />
        )}
      </div>
      <div>
        <input
          type="file"
          accept="image/*"
          onChange={onAvatarChange}
          className="hidden"
          id="avatar-upload"
        />
        <label
          htmlFor="avatar-upload"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-xs bg-primary text-white rounded-lg hover:bg-primary-600 transition-all font-medium cursor-pointer shadow-sm"
        >
          <UserCircleIcon className="h-4 w-4" />
          {t('profile.chooseImage', 'Choose Image')}
        </label>
        <p className="text-xs text-gray-500 mt-1.5">
          {t('profile.imageRequirements', 'Max 500KB, JPG/PNG')}
        </p>
        {avatarPreview && (
          <button
            type="button"
            onClick={onRemoveAvatar}
            className="flex items-center gap-1 text-xs text-red-600 hover:text-red-700 mt-1"
          >
            <XMarkIcon className="h-3 w-3" />
            {t('profile.removeImage', 'Remove')}
          </button>
        )}
      </div>
    </div>
  )
})

export default AvatarUploadField
